<script setup lang="ts">
import { YandexMapMarker } from 'vue-yandex-maps'

import { useAddressSystemStore } from '@/store/addressSystem'
import { BalloonType } from '@/store/delivery/delivery.types'

import { DeliveryMethods } from '@/api/modules/basket/types'
import { PointProperties } from '@/api/modules/delivery/types'

import BalloonMarker from '@/components/Services/Balloons/BalloonMarker.vue'
type Props = {
  points: PointProperties[]
  clickedRestaurant: PointProperties | null
}

const props = defineProps<Props>()

const generateSettings = (marker: PointProperties) => {
  return {
    id: `${marker.id}`,
    coordinates: [marker.coordinates.lon, marker.coordinates.lat],
    properties: { ...marker },
  }
}

// Определение иконки точки ресторана
const getImageSrc = (isWorking: boolean) =>
  isWorking ? '/opened-marker.svg' : '/closed-marker.svg'

const { deliveryBasket } = storeToRefs(useAddressSystemStore())

const balloonText = computed(() => {
  let time = 0

  switch (deliveryBasket.value.delivery_method) {
    case DeliveryMethods.COURIER:
      time = props.clickedRestaurant?.total_order_time || 0
      break

    case DeliveryMethods.PICKUP:
      time = props.clickedRestaurant?.pickup_cooking_time || 0
      break

    case DeliveryMethods.HALL:
      time = props.clickedRestaurant?.dinein_cooking_time || 0
      break
  }

  if (!time) return ''

  return `~${time} мин.`
})
</script>

<template>
  <yandex-map-marker
    v-for="(marker, index) in points"
    :key="`point-${index}-${marker.id}`"
    position="top-center left-center"
    :settings="generateSettings(marker)"
  >
    <div class="marker">
      <balloon-marker
        v-if="clickedRestaurant?.id === marker.id"
        class="yandex-map__mobile-point"
        :balloon-type="BalloonType.AddressSystem"
        :balloon-text="balloonText"
        :details="null"
        :selected-address="null"
      />

      <nuxt-img
        v-else
        class="marker__image"
        :src="getImageSrc(marker.is_open)"
        alt="Маркер точки"
        width="36"
        height="64"
      />
    </div>
  </yandex-map-marker>
</template>

<style lang="scss" scoped>
.marker {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  transform: translateY(-50%);

  &__image {
    max-width: unset;
    cursor: pointer;
    background-size: cover;
  }

  &__baloon {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: -1;
    width: -moz-max-content;
    width: max-content;
    height: 25px;
    padding: 2px 20px;
    font-size: 14px;
    color: var(--ui-text-primary);
    background: var(--ui-white);
    border-radius: 0 5px 5px 0;
    box-shadow: -8px 6px 13px -9px rgb(0 0 0 / 90%);
  }
}
</style>
